<section class="our-services" style="direction: ltr; margin-bottom: -80px;">
    <div class="container-fluid">
        <div class="row">

            <div class="col-md-12">

                <ngx-slick-carousel 
                    class="carousel" 
                    style="padding-bottom: 10px;"
                    #slickModal="slick-carousel" 
                    [config]="slideConfig">
                    <div ngxSlickItem *ngFor="let slide of slides;let i = index" class="slide">
                        <div (click)="navigateToindex(i)" class="service-wrapper text-center">
                            <div class="service-title">
                                <h4>{{slide.title}}</h4>
                            </div>
                        </div>
                    </div>
                </ngx-slick-carousel>

                <ngx-slick-carousel 
                    class="carousel-desc" 
                    #slickModal="slick-carousel" 
                    [config]="slideConfigDesc">
                    <div ngxSlickItem *ngFor="let offer of offers" class="slide-desc">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="offer-wrapper">
                                    <div class="offer-title">
                                        <h4>{{offer.title}}</h4>
                                    </div>
                                    <div class="offer-description">
                                        <p>
                                            {{offer.desc}}
                                        </p>
                                    </div>                    
                                    <div class="offer-img">
                                        <img src="{{offer.img}}" alt="" />
                                    </div>                    
                                </div>
                            </div>                            
                        </div>
                    </div>                    
                </ngx-slick-carousel>            

            </div>  

        </div>
    </div>
</section>